export const PAGE_CONFIG = {
  "title": "Daily",
  "titleCN": "运营总况日报",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/overview/daily-v3",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "tabName": "Overall",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "notificationPath": "/overview/daily-v3",
      "path": "/overview/daily-v3/overall",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "204401",
        "pageName": "dailyV3Overall",
        "extInfo": "dailyV3Overall",
        "pagePath": "/overview/daily-v3/overall"
      },
      "filters": [
        {
          "name": "PcConsoleDailyFilterV3",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/daily-v3",
          "componentList": [
            {
              "name": "KeyMetricTitle",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_daily/country_region_platform",
                  "metric": "units"
                }
              }
            },
            {
              "name": "PlatformMetricsCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                  "metricsList": [
                    "units_number",
                    "net_revenue"
                  ]
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PlatformCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/monetization/salesOverview",
                              "componentMetrics": [
                                {
                                  "metricKey": "units_number",
                                  "enName": "Base Game Units After Refund",
                                  "cnName": "本体拷贝净销量",
                                  "rangeEnName": "Base Game Units After Refund",
                                  "rangeCnName": "本体拷贝净销量",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics Full Game Units",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "game",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PlatformCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/monetization/salesOverview",
                              "componentMetrics": [
                                {
                                  "metricKey": "net_revenue",
                                  "enName": "Revenue After Refund & Tax",
                                  "cnName": "净收入",
                                  "rangeEnName": "Revenue After Refund & Tax",
                                  "rangeCnName": "净收入",
                                  "endEnName": "Estimated",
                                  "endCnName": "估算",
                                  "preUnit": "$",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics Net Revenue",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "dollar",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "KeyMetricsCo",
              "className": "dbd-daily-card",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                  "haveJump": true,
                  "mainMetricsList": [
                    "active_users",
                    "new_users",
                    "d1t1",
                    "median_online_time",
                    "median_session_time",
                    "pcu"
                  ],
                  "metricsList": [
                    "active_users",
                    "new_users",
                    "d1t1",
                    "median_online_time",
                    "aot_hour",
                    "above_2hr_users",
                    "median_session_time",
                    "avg_session_time",
                    "avg_session_cnt",
                    "pcu",
                    "pcu_active_users_rate",
                    "acu",
                    "d2t2",
                    "d7t7"
                  ]
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/engagement/active",
                              "componentMetrics": [
                                {
                                  "metricKey": "active_users",
                                  "enName": "DAU",
                                  "cnName": "日活跃",
                                  "rangeEnName": "Avg.DAU",
                                  "rangeCnName": "平均日活跃",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics DAU",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-u",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/engagement/register",
                              "componentMetrics": [
                                {
                                  "metricKey": "new_users",
                                  "enName": "New",
                                  "cnName": "新进用户",
                                  "rangeEnName": "New",
                                  "rangeCnName": "新进用户",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics New",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-plus",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/engagement/active",
                              "componentMetrics": [
                                {
                                  "metricKey": "pcu",
                                  "enName": "PCU",
                                  "cnName": "最高同时在线",
                                  "rangeEnName": "Avg.PCU",
                                  "rangeCnName": "日平均最高同时在线",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics PCU",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-pcu",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/retention/index",
                              "componentMetrics": [
                                {
                                  "metricKey": "d1t1",
                                  "enName": "D1(T-1)",
                                  "cnName": "次留(T-1)",
                                  "rangeEnName": "D1(T-1)",
                                  "rangeCnName": "次留(T-1)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics D1(T-1)",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "user-success",
                                  "position": ""
                                },
                                {
                                  "metricKey": "d2t2",
                                  "enName": "D2(T-2)",
                                  "cnName": "2留(T-2)",
                                  "rangeEnName": "D2(T-2)",
                                  "rangeCnName": "2留(T-2)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc D2",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "",
                                  "position": ""
                                },
                                {
                                  "metricKey": "d7t7",
                                  "enName": "D7(T-7)",
                                  "cnName": "7留(T-7)",
                                  "rangeEnName": "D7(T-7)",
                                  "rangeCnName": "7留(T-7)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc D7",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/engagement/active/onlineAnalysis",
                              "componentMetrics": [
                                {
                                  "metricKey": "median_online_time",
                                  "enName": "Median Playtime",
                                  "cnName": "在线时长中位数",
                                  "rangeEnName": "Avg.Median Playtime",
                                  "rangeCnName": "平均在线时长中位数",
                                  "preUnit": "",
                                  "endUnit": "H",
                                  "rainbowKey": "Pc V2 Metrics Playtime",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "pie-chart-icon",
                                  "position": ""
                                },
                                {
                                  "metricKey": "aot_hour",
                                  "enName": "Avg.Playtime",
                                  "cnName": "平均在线时长",
                                  "rangeEnName": "Avg.Playtime",
                                  "rangeCnName": "平均在线时长",
                                  "preUnit": "",
                                  "endUnit": "H",
                                  "rainbowKey": "Pc Avg.Playtime(h)",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "",
                                  "position": ""
                                },
                                {
                                  "metricKey": "above_2hr_users",
                                  "enName": "Playtime over 2h+ new users",
                                  "cnName": "在线时长2小时以上新进用户数",
                                  "rangeEnName": "Avg.Playtime over 2h+ new users",
                                  "rangeCnName": "平均在线时长2小时以上新进用户数",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics Playtime over 2h+ new users",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/engagement/active/onlineAnalysis",
                              "componentMetrics": [
                                {
                                  "metricKey": "median_session_time",
                                  "enName": "Median Session",
                                  "cnName": "会话时长中位数",
                                  "rangeEnName": "Avg.Median Session",
                                  "rangeCnName": "平均会话时长中位数",
                                  "preUnit": "",
                                  "endUnit": "H",
                                  "rainbowKey": "Pc Metrics Session",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "user-session",
                                  "position": ""
                                },
                                {
                                  "metricKey": "avg_session_time",
                                  "enName": "Avg.Session Length",
                                  "cnName": "日均会话时长",
                                  "rangeEnName": "Avg.Session Length",
                                  "rangeCnName": "日均会话时长",
                                  "preUnit": "",
                                  "endUnit": "H",
                                  "rainbowKey": "Pc Metrics Avg.Session Length",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "",
                                  "position": ""
                                },
                                {
                                  "metricKey": "avg_session_cnt",
                                  "enName": "Avg.Session count",
                                  "cnName": "用户日均会话数",
                                  "rangeEnName": "Avg.Session count",
                                  "rangeCnName": "用户日均会话数",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics Avg.Session count",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "EventService",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "10px"
              },
              "props": {},
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "OverviewMetricsTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "renderIndex": 0,
                              "api": {
                                "metricsApi": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                                "dimensionApi": "/api/v1/dashboard/pc/overview_daily/dimension/metrics_trend"
                              },
                              "componentMetrics": [
                                {
                                  "enName": "DAU",
                                  "cnName": "日活跃",
                                  "metricKey": "active_users",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "New",
                                  "cnName": "新进用户",
                                  "metricKey": "new_users",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "D1",
                                  "cnName": "次留",
                                  "metricKey": "d1",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "D2",
                                  "cnName": "2留",
                                  "metricKey": "d2",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "D7",
                                  "cnName": "7留",
                                  "metricKey": "d7",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "TNU",
                                  "cnName": "总注册用户数",
                                  "metricKey": "total_users",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "PCU",
                                  "cnName": "最高同时在线",
                                  "metricKey": "pcu",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "Median Playtime",
                                  "cnName": "在线时长中位数",
                                  "metricKey": "median_online_time",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "Median Session",
                                  "cnName": "会话时长中位数",
                                  "metricKey": "median_session_time",
                                  "type": "decimals",
                                  "decimal": 2
                                }
                              ]
                            }
                          }
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "OverviewMetricsTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "renderIndex": 1,
                              "api": {
                                "metricsApi": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                                "dimensionApi": "/api/v1/dashboard/pc/overview_daily/dimension/metrics_trend"
                              },
                              "componentMetrics": [
                                {
                                  "enName": "Rev After Refund & Tax($)",
                                  "cnName": "净收入",
                                  "metricKey": "net_revenue",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "Base Game Units After Refund",
                                  "cnName": "本体拷贝净销量",
                                  "metricKey": "units_number",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "Revenue($)",
                                  "cnName": "收入($)",
                                  "metricKey": "gross_revenue",
                                  "type": "decimals",
                                  "decimal": 2
                                }
                              ]
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "OverviewTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/overview_daily/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/overview_daily/overall_performance/download"
                  },
                  "componentMetrics": [
                    {
                      "metricKey": "total_users",
                      "reqMetricKey": "total_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 130,
                      "enName": "TNU",
                      "cnName": "总注册用户数",
                      "rainbowKey": "Pc TNU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_users",
                      "reqMetricKey": "new_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "New",
                      "cnName": "新进用户",
                      "rainbowKey": "Pc New",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "active_users",
                      "reqMetricKey": "active_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "DAU",
                      "cnName": "日活跃",
                      "rainbowKey": "Pc DAU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "net_revenue",
                      "reqMetricKey": "net_revenue",
                      "enPercentWidth": 270,
                      "cnPercentWidth": 190,
                      "enWidth": 270,
                      "cnWidth": 130,
                      "enName": "Revenue After Refund & Tax($)",
                      "cnName": "净收入($)",
                      "rainbowKey": "Pc Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "units_number",
                      "reqMetricKey": "units_number",
                      "enPercentWidth": 260,
                      "cnPercentWidth": 180,
                      "enWidth": 260,
                      "cnWidth": 155,
                      "enName": "Base Game Units After Refund",
                      "cnName": "本体拷贝净销量",
                      "rainbowKey": "Pc Units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "gross_revenue",
                      "reqMetricKey": "gross_revenue",
                      "enPercentWidth": 210,
                      "cnPercentWidth": 160,
                      "enWidth": 160,
                      "cnWidth": 160,
                      "enName": "Revenue($)",
                      "cnName": "收入($)",
                      "rainbowKey": "Pc Gross Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "d1",
                      "reqMetricKey": "d1",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D1",
                      "cnName": "次留",
                      "rainbowKey": "Pc D1",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d2",
                      "reqMetricKey": "d2",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D2",
                      "cnName": "2留",
                      "rainbowKey": "Pc D2",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d3",
                      "reqMetricKey": "d3",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D3",
                      "cnName": "3留",
                      "rainbowKey": "Pc D3",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d4",
                      "reqMetricKey": "d4",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D4",
                      "cnName": "4留",
                      "rainbowKey": "Pc D4",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d5",
                      "reqMetricKey": "d5",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D5",
                      "cnName": "5留",
                      "rainbowKey": "Pc D5",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d6",
                      "reqMetricKey": "d6",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D6",
                      "cnName": "6留",
                      "rainbowKey": "Pc D6",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d7",
                      "reqMetricKey": "d7",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D7",
                      "cnName": "7留",
                      "rainbowKey": "Pc D7",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d14",
                      "reqMetricKey": "d14",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D14",
                      "cnName": "14留",
                      "rainbowKey": "Pc D14",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d30",
                      "reqMetricKey": "d30",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D30",
                      "cnName": "30留",
                      "rainbowKey": "Pc D30",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "pcu",
                      "reqMetricKey": "pcu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 122,
                      "enName": "PCU",
                      "cnName": "最高同时在线",
                      "rainbowKey": "PCU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "acu",
                      "reqMetricKey": "acu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 122,
                      "enName": "ACU",
                      "cnName": "平均同时在线",
                      "rainbowKey": "ACU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "median_online_time",
                      "reqMetricKey": "median_online_time",
                      "enPercentWidth": 200,
                      "cnPercentWidth": 200,
                      "enWidth": 175,
                      "cnWidth": 175,
                      "enName": "Median Playtime(h)",
                      "cnName": "在线时长中位数(小时)",
                      "rainbowKey": "Pc V2 Metrics Playtime",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "aot_hour",
                      "reqMetricKey": "aot_hour",
                      "enPercentWidth": 170,
                      "cnPercentWidth": 190,
                      "enWidth": 145,
                      "cnWidth": 170,
                      "enName": "Avg.Playtime(h)",
                      "cnName": "平均在线时长(小时)",
                      "rainbowKey": "Pc Avg.Playtime(h)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "above_2hr_users",
                      "reqMetricKey": "above_2hr_users",
                      "enPercentWidth": 280,
                      "cnPercentWidth": 300,
                      "enWidth": 250,
                      "cnWidth": 280,
                      "enName": "Playtime over 2h+ new users",
                      "cnName": "平均在线时长2小时以上新进用户数",
                      "rainbowKey": "Pc Metrics Playtime over 2h+ new users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "median_session_time",
                      "reqMetricKey": "median_session_time",
                      "enPercentWidth": 170,
                      "cnPercentWidth": 160,
                      "enWidth": 145,
                      "cnWidth": 135,
                      "enName": "Median Session",
                      "cnName": "会话时长中位数",
                      "rainbowKey": "Pc Metrics Session",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "avg_session_time",
                      "reqMetricKey": "avg_session_time",
                      "enPercentWidth": 200,
                      "cnPercentWidth": 160,
                      "enWidth": 180,
                      "cnWidth": 135,
                      "enName": "Avg.Session Length",
                      "cnName": "日均会话时长",
                      "rainbowKey": "Pc Metrics Avg.Session Length",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "avg_session_cnt",
                      "reqMetricKey": "avg_session_cnt",
                      "enPercentWidth": 200,
                      "cnPercentWidth": 160,
                      "enWidth": 180,
                      "cnWidth": 135,
                      "enName": "Avg.Session count",
                      "cnName": "用户日均会话数",
                      "rainbowKey": "Pc Metrics Avg.Session count",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "retention_users",
                      "reqMetricKey": "retention_users",
                      "enPercentWidth": 220,
                      "cnPercentWidth": 150,
                      "enWidth": 190,
                      "cnWidth": 120,
                      "enName": "DAU Retention Users",
                      "cnName": "日活留存",
                      "rainbowKey": "DAU Retention Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "churn_users",
                      "reqMetricKey": "churn_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 130,
                      "enWidth": 130,
                      "cnWidth": 100,
                      "enName": "Churn Users",
                      "cnName": "日流失",
                      "rainbowKey": "Churn Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "churn_rate",
                      "reqMetricKey": "churn_rate",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 80,
                      "cnWidth": 86,
                      "enName": "Churn%",
                      "cnName": "流失率",
                      "rainbowKey": "Churn%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "return_users",
                      "reqMetricKey": "return_users",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 150,
                      "enWidth": 160,
                      "cnWidth": 95,
                      "enName": "DAU Return Users",
                      "cnName": "日回流",
                      "rainbowKey": "DAU Return Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d2",
                      "reqMetricKey": "weighted_d2",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 122,
                      "cnWidth": 80,
                      "enName": "Weighted D1",
                      "cnName": "加权次留",
                      "rainbowKey": "Weighted D1",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d3",
                      "reqMetricKey": "weighted_d3",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 122,
                      "cnWidth": 80,
                      "enName": "Weighted D2",
                      "cnName": "加权2留",
                      "rainbowKey": "Weighted D2",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d7",
                      "reqMetricKey": "weighted_d7",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 122,
                      "cnWidth": 80,
                      "enName": "Weighted D6",
                      "cnName": "加权6留",
                      "rainbowKey": "Weighted D6",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d14",
                      "reqMetricKey": "weighted_d14",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 132,
                      "cnWidth": 90,
                      "enName": "Weighted D13",
                      "cnName": "加权13留",
                      "rainbowKey": "Weighted D13",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "first_login_ratio",
                      "reqMetricKey": "first_login_ratio",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 145,
                      "enWidth": 160,
                      "cnWidth": 145,
                      "enName": "1st Order Login%",
                      "cnName": "一阶登录比",
                      "rainbowKey": "1st Order Login%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "second_login_ratio",
                      "reqMetricKey": "second_login_ratio",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 145,
                      "enWidth": 160,
                      "cnWidth": 145,
                      "enName": "2nd Order Login%",
                      "cnName": "二阶登录比",
                      "rainbowKey": "2nd Order Login%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "id": "breakdown",
      "tabName": "Daily Breakdown",
      "tabNameCN": "每日细分",
      "isHaveNotification": true,
      "notificationPath": "/overview/daily-v3",
      "path": "/overview/daily-v3/breakdown",
      "tabIcon": "pie-chart-icon",
      "logConfig": {
        "pageId": "204402",
        "pageName": "dailyV3Breakdown",
        "extInfo": "dailyV3Breakdown",
        "pagePath": "/overview/daily-v3/breakdown"
      },
      "filters": [
        {
          "name": "PcConsoleDailyFilterV3",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/daily-v3",
          "componentList": [
            {
              "name": "CommonRow",
              "className": "",
              "type": "layout",
              "style": {
                "marginTop": "10px"
              },
              "props": {},
              "children": [
                {
                  "name": "UserCompositionCo",
                  "className": "",
                  "type": "view",
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/overview_daily/metrics_users"
                    }
                  },
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "MetricsUserCompositionCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "jumpUrl": "/engagement/active",
                              "timeType": "DAY",
                              "metricType": "dau",
                              "tooltipConfig": {
                                "valueNameEn": "DAU",
                                "valueNameCn": "日活跃"
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "MetricsUserCompositionCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "jumpUrl": "/engagement/register",
                              "timeType": "DAY",
                              "metricType": "system",
                              "tooltipConfig": {
                                "valueNameEn": "New Users",
                                "valueNameCn": "新进用户"
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "CommonRow",
              "className": "",
              "type": "layout",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "RankListTabCo",
                  "className": "",
                  "style": {},
                  "type": "view",
                  "data": {
                    "regionDataType": "os"
                  },
                  "children": [
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_daily/country_region_platform",
                          "jumpUrl": "/engagement/active",
                          "metric": "dau",
                          "haveCalBubble": false,
                          "isUserQuota": true,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    },
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_daily/country_region_platform",
                          "jumpUrl": "/engagement/register",
                          "metric": "new",
                          "haveCalBubble": false,
                          "isUserQuota": true,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    },
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_daily/country_region_platform",
                          "jumpUrl": "/monetization/salesOverview",
                          "metric": "units",
                          "haveCalBubble": true,
                          "isUserQuota": true,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    },
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_daily/country_region_platform",
                          "jumpUrl": "/monetization/salesOverview",
                          "metric": "revenue",
                          "haveCalBubble": true,
                          "isUserQuota": false,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "operationList": [
    {
      "nameEn": "情报",
      "nameCn": "Intelligence",
      "url": "function(data) { const { unifiedid } = data; return '/intelligence/topCharts/pcGames/gamesDetails/' + unifiedid; }"
    },
    {
      "nameEn": "舆情",
      "nameCn": "Opinions",
      "url": "/opinion/Overview",
      "params": {
        "gameid": "unifiedid"
      },
      "permission": "hasOpinionPermissions"
    }
  ]
};